import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
import { initSentry } from './config/sentry.js'
import { store } from './store/store.js'
import App from './App.jsx'
import './styles/global.css'

// Before the first render, so errors thrown while mounting are reported too.
initSentry()

const crashFallback = (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h2>Something went wrong.</h2>
    <p>The error has been reported. Reload the page to continue.</p>
    <button onClick={() => window.location.reload()}>Reload</button>
  </div>
)

ReactDOM.createRoot(document.getElementById('root'), {
  // React 19 no longer rethrows render errors to window.onerror, so Sentry's
  // global handlers never see them without these hooks.
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={crashFallback}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
